import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bs-search",
  ref: "containerReference"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m21 21-4.34-4.34" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_field = _resolveComponent("bs-field")!
  const _component_bs_dropdown_tooltip = _resolveComponent("bs-dropdown-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_field, {
      ref: "reference",
      size: _ctx.size,
      modelValue: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      loading: _ctx.loading,
      "onUpdate:modelValue": _ctx.onUpdateModelValue,
      onChange: _ctx.onChange,
      onInput: _ctx.onInput,
      onFocus: _ctx.onFocus,
      onBlur: _ctx.onBlur
    }, {
      "icon-left": _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["size", "modelValue", "placeholder", "disabled", "loading", "onUpdate:modelValue", "onChange", "onInput", "onFocus", "onBlur"]),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createBlock(_component_bs_dropdown_tooltip, {
              key: 0,
              ref: "tooltip",
              position: _ctx.strategy,
              x: _ctx.x,
              y: _ctx.y
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["position", "x", "y"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}